export default {
  data() {
    return {
      transfer: [
        {
          id: 1,
          name: "Types",
          alias: "types"
        }
      ]
    };
  },

  created() {
    const allowedTabs = [
      {
        id: 2,
        name: "Direction",
        alias: "dir"
      },
      {
        id: 3,
        name: "Users",
        alias: "users",
        presetTabs: true,
        statisticTab: true
      },
      {
        id: 4,
        name: "Place",
        alias: "place"
      }
    ];

    if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12])) {
      this.transfer = [...this.transfer, ...allowedTabs];
    }
  }
};
